
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoCNRTVEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoCNRTVRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoCNRTVRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
